module.exports = __webpack_public_path__ + "static/media/bell.07e5533e.svg";